(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ginniSizeSelectorBound) return;
    window.__ginniSizeSelectorBound = true;

    const storageKey = (root) => {
      const productId = root.closest('product-form-component')?.dataset.productId;
      return productId ? 'ginni-size-selection-' + productId : null;
    };

    const updateRoot = (root, size, method, persist = true) => {
      const selectedSize = [...root.querySelectorAll('[data-ginni-size-choice]')]
        .find((input) => input.dataset.ginniSizeChoice === size);
      const selectedMethod = [...root.querySelectorAll('[data-ginni-fit-choice]')]
        .find((input) => input.dataset.ginniFitChoice === method);
      if (!(selectedSize instanceof HTMLInputElement) || !(selectedMethod instanceof HTMLInputElement)) return;
      selectedSize.checked = true;
      selectedMethod.checked = true;

      const custom = size === 'custom';
      const fields = root.querySelector('[data-ginni-custom-fields]');
      if (fields instanceof HTMLFieldSetElement) {
        fields.hidden = !custom;
        fields.disabled = !custom;
      }
      root.querySelectorAll('[data-ginni-standard-field]').forEach((field) => {
        field.disabled = custom;
      });

      root.querySelectorAll('[data-ginni-fit-panel]').forEach((panel) => {
        const active = custom && panel.dataset.ginniFitPanel === method;
        panel.hidden = !active;
        panel.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !active;
          if (field.hasAttribute('data-ginni-required')) {
            field.required = active;
            field.setAttribute('aria-required', String(active));
          }
        });
      });

      const status = root.querySelector('[data-ginni-measurement-status]');
      if (status instanceof HTMLInputElement) {
        status.value = method === 'measurements' ? 'Provided with order'
          : method === 'size' ? 'Usual size + fit assistance' : 'Pending after checkout';
      }

      if (persist) {
        const key = storageKey(root);
        if (key) {
          try { sessionStorage.setItem(key, JSON.stringify({ size, method })); } catch (_) {}
        }
      }
    };

    const initRoot = (root) => {
      if (!(root instanceof HTMLElement)) return;
      let saved;
      const key = storageKey(root);
      if (key) {
        try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) {}
      }
      const sizes = [...root.querySelectorAll('[data-ginni-size-choice]')];
      const methods = [...root.querySelectorAll('[data-ginni-fit-choice]')];
      const savedSize = ['XXS', 'XXXL', '3XL', '4XL', '5XL'].includes(saved?.size) ? 'custom' : saved?.size;
      const size = sizes.some((input) => input.dataset.ginniSizeChoice === savedSize)
        ? savedSize : sizes.find((input) => input.checked)?.dataset.ginniSizeChoice || '';
      const method = methods.some((input) => input.dataset.ginniFitChoice === saved?.method)
        ? saved.method : methods.find((input) => input.checked)?.dataset.ginniFitChoice || 'later';
      updateRoot(root, size, method, false);
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-ginni-chart-open], [data-ginni-chart-close], [data-ginni-chart-unit]');
      if (!(button instanceof HTMLButtonElement)) return;
      const dialog = button.closest('[data-ginni-size-selector]')?.querySelector('[data-ginni-chart-dialog]');
      if (!(dialog instanceof HTMLDialogElement)) return;
      if (button.hasAttribute('data-ginni-chart-open')) {
        if (!dialog.open) dialog.showModal();
        return;
      }
      if (button.hasAttribute('data-ginni-chart-close')) {
        dialog.close();
        return;
      }
      const unit = button.dataset.ginniChartUnit;
      if (unit !== 'in' && unit !== 'cm') return;
      dialog.dataset.unit = unit;
      dialog.querySelectorAll('[data-ginni-chart-unit]').forEach((control) => {
        control.setAttribute('aria-pressed', String(control.dataset.ginniChartUnit === unit));
      });
      dialog.querySelectorAll('[data-ginni-chart-caption]').forEach((caption) => {
        caption.hidden = caption.dataset.ginniChartCaption !== unit;
      });
      dialog.querySelectorAll('[data-ginni-chart-inches]').forEach((cell) => {
        const inches = cell.dataset.ginniChartInches;
        cell.textContent = unit === 'in' ? inches
          : inches.split('-').map((value) => String(Math.round(Number(value) * 254) / 100)).join('–');
      });
    });

    document.querySelectorAll('[data-ginni-size-selector]').forEach(initRoot);

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)
        || !target.matches('[data-ginni-size-choice], [data-ginni-fit-choice]')) return;
      const root = target.closest('[data-ginni-size-selector]');
      if (!root) return;
      const size = root.querySelector('[data-ginni-size-choice]:checked')?.dataset.ginniSizeChoice || '';
      const method = root.querySelector('[data-ginni-fit-choice]:checked')?.dataset.ginniFitChoice || 'later';
      updateRoot(root, size, method);
    });

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          if (node.matches('[data-ginni-size-selector]')) initRoot(node);
          node.querySelectorAll('[data-ginni-size-selector]').forEach(initRoot);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
